import { createSlice } from '@reduxjs/toolkit';
import {ResponseApi} from "../BaseApi";

const UserFileSlice = createSlice({
    name: 'userFileSection',
    initialState: {
        getAllUserFiles:[]
    },
    reducers: {},
    extraReducers: {
        'userFileSection/getAllUserFiles/fulfilled': (state, action) => {
            state.getAllUserFiles = ResponseApi(action.payload);
        },
    },
});

export const {} = UserFileSlice.actions;

export default UserFileSlice.reducer;
